import { handleActions } from "redux-actions";

import {
    getQuotaTypes,
    getQuotaTypesSuccess,
    getQuotaTypesError,
} from "modules/QuotaManager/services/QuotaTypes/actions";

const initialState = {
    isLoading: false,
    count: 0,
    types: [],
};

export const quotaTypesReducer = handleActions(
    {
        [getQuotaTypes]: (state) => ({
            ...state,
            types: [],
            count: 0,
            isLoading: true
        }),
        [getQuotaTypesSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getQuotaTypesError]: (state) => ({
            ...state,
            isLoading: false
        }),
    },
    initialState
);
